import React from 'react';

const SectionHeader = ({ title, className = '' }) => {
  return (
    <div className={`flex items-center gap-2 mb-2 ${className}`}>
      <div className="w-1 h-5 bg-[#3F5B3B]" />
      <span className="text-[20px] leading-[30px] font-bold text-[#333333]">
        {title}
      </span>
    </div>
  );
};

export default SectionHeader;

